import { init } from '@fullstory/browser'

export const initialize = () => {
  if (process.env.REACT_APP_FULLSTORY_ORG_ID) {
    init({ orgId: process.env.REACT_APP_FULLSTORY_ORG_ID })
  }
}
